'use client';

import { ChartLine } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import useTrendingSearch from '@/hooks/use-trending-search';
import TrendingList from './TrendingList';
import ResearchHotIcon from '@/components/Icons/ResearchHotIcon';

export default function Trending() {
  const { t } = useTranslation();
  const { list: trendingList, isLoading } = useTrendingSearch();

  return (
    <div className="mt-12.5!">
      <div className="flex items-center gap-2 mb-3">
        <ResearchHotIcon width={20} height={20} className="text-[#FF6705]" />
        <h2 className="font-semibold text-sm">{t('Trending Searches')}</h2>
      </div>
      <TrendingList loading={isLoading} list={trendingList} />
    </div>
  );
}
